import { SITE } from "@/lib/site";
import { ShieldCheck, Clock, Truck, MapPin } from "lucide-react";

const FEATURES = [
  {
    icon: ShieldCheck,
    title: "Fully Insured & Compliant",
    body: "Bonded cross-border carrier with full insurance coverage and DOT/MELT compliance.",
  },
  {
    icon: Clock,
    title: "24/7 Dispatch",
    body: "Real humans answering at 2 AM. Hotshot, breakdown coverage, and last-minute loads.",
  },
  {
    icon: Truck,
    title: "Modern Maintained Fleet",
    body: "Ram heavy-duty trucks, flatbeds, and trailers — inspected and ready to roll.",
  },
  {
    icon: MapPin,
    title: "Canada / US Coverage",
    body: "Western Canada based with regular cross-border runs into the United States.",
  },
];

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-[#0d0d0d] py-24 lg:py-32 border-t border-[#161616] overflow-hidden"
    >
      <div className="absolute -top-32 -right-32 w-[500px] h-[500px] bg-[#1E5BFF]/10 blur-[120px] rounded-full pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-5">
          <div className="inline-flex items-center gap-3 mb-5">
            <span className="h-[2px] w-10 bg-[#1E5BFF]" />
            <span className="font-display text-xs font-bold uppercase tracking-[0.3em] text-[#1E5BFF]">
              Why Coreline
            </span>
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black uppercase text-white tracking-tighter leading-[0.95]">
            We Don't Just
            <br />
            Move Loads —
            <br />
            <span className="text-[#1E5BFF]">We Move Yours.</span>
          </h2>
          <p className="mt-6 text-slate-400 text-base md:text-lg leading-relaxed max-w-md">
            Coreline Heavy Haul & Hotshot is built on a simple promise: heavy duty work, done on
            time, every time. Whether it's a single skid that has to be there by morning or a
            multi-axle oversized haul through the Rockies, we treat your freight like our reputation
            depends on it — because it does.
          </p>

          <div className="mt-10 flex flex-wrap gap-3">
            {SITE.trust.map((t) => (
              <span
                key={t}
                data-testid={`trust-pill-${t.toLowerCase().replace(/\s+/g, "-").replace(/&/g, "and")}`}
                className="font-display text-[11px] font-bold uppercase tracking-[0.2em] text-white/85 px-4 py-2 border border-[#222] bg-[#121212]"
              >
                ◆ {t}
              </span>
            ))}
          </div>
        </div>

        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-px bg-[#1a1a1a]">
          {FEATURES.map((f) => (
            <div
              key={f.title}
              data-testid={`about-feature-${f.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="card-industrial p-8 min-h-[200px] flex flex-col"
            >
              <div className="w-12 h-12 flex items-center justify-center border border-[#1E5BFF]/40 bg-[#0d1430] mb-5">
                <f.icon size={22} className="text-[#1E5BFF]" />
              </div>
              <h3 className="font-display text-xl font-bold uppercase text-white tracking-tight">
                {f.title}
              </h3>
              <p className="mt-3 text-sm text-slate-400 leading-relaxed">{f.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
